// import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import EditorialSlides from 'components/editorial/editorial-slides'
// import HomepageContent from './content'
import compose from 'recompose/compose'
import { bindActionCreators } from 'redux'
import { withI18next } from 'lib/i18n/withI18next'
import PropTypes from 'prop-types'
import homefeedDuck from './homefeed/duck'
import HomepageSuperDeals from './home-page-super-deals/HomepageSuperDeals'
import { getHomefeedBubbleNavigations, getHomefeedBanners } from './utils'
import homePageDuck from './duck'
import HomepageContent from './home-page-content/HomePageContent'

const HomepageContainer = ({
  isPhone,
  homefeed,
  getHomefeed,
  resetHomePage,
  updateBanners,
  updateTopNavigations,
  updateBottomNavigations,
  updateSelectedTopNavigation,
}) => {
  // clear top-navigation state on unmount so it doesn't leak into the
  // header on other pages when navigating away client-side
  useEffect(() => () => resetHomePage(), [resetHomePage])

  useEffect(() => {
    const initializeBanners = () => {
      const banners = getHomefeedBanners(homefeed.payload, isPhone)
      updateBanners(banners)
    }
    const initializeNavigations = () => {
      const navigations = getHomefeedBubbleNavigations(homefeed.payload)
      updateTopNavigations(navigations?.topNavigations)
      updateBottomNavigations(navigations?.bottomNavigations)
      updateSelectedTopNavigation(navigations?.topNavigations?.[0])
    }

    if (homefeed?.payload) {
      initializeBanners()
      initializeNavigations()
    }
  }, [
    homefeed?.payload,
    isPhone,
    updateBanners,
    updateTopNavigations,
    updateBottomNavigations,
    updateSelectedTopNavigation,
  ])

  useEffect(() => {
    getHomefeed(isPhone ? 'phone' : 'desktop')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPhone])

  return (
    <div className="home-product-discovery">
      <EditorialSlides />
      <HomepageSuperDeals />
      <HomepageContent />
      {/* <HomepageContent isPhone={isPhone} /> */}
    </div>
  )
}

HomepageContainer.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  homefeed: PropTypes.shape({
    isFetching: PropTypes.bool,
    payload: PropTypes.shape({}),
  }).isRequired,
  getHomefeed: PropTypes.func.isRequired,
  resetHomePage: PropTypes.func.isRequired,
  updateBanners: PropTypes.func.isRequired,
  updateTopNavigations: PropTypes.func.isRequired,
  updateBottomNavigations: PropTypes.func.isRequired,
  updateSelectedTopNavigation: PropTypes.func.isRequired,
}

export default compose(
  connect(
    (state) => ({
      homefeed: state.homefeed,
      isPhone: state.device.isPhone,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          getHomefeed: homefeedDuck.creators.get,
          resetHomePage: homePageDuck.creators.reset,
          updateBanners: homePageDuck.creators.updateBanners,
          updateTopNavigations: homePageDuck.creators.updateTopNavigations,
          updateBottomNavigations:
            homePageDuck.creators.updateBottomNavigations,
          updateSelectedTopNavigation:
            homePageDuck.creators.updateSelectedTopNavigation,
        },
        dispatch,
      ),
  ),
  withI18next(),
)(HomepageContainer)
